module.exports = __webpack_public_path__ + "img/loans.80b8feb.png";